import { QUIPU, QUIPU_CENTER_Y, quipuShapes } from '../../lib/brand/quipu.ts'
import './QuipuMark.css'

const SHAPES = quipuShapes()
// Centre the drawing vertically in its 32-unit box, like the icons.
const VIEW_BOX = `0 ${QUIPU_CENTER_Y - 16} 32 32`

/**
 * The QUIPWA mark, a quipu (see lib/brand/quipu.ts for the idea and the
 * geometry it shares with the favicon and the app icons).
 *
 * Cords take `currentColor` and knots `--quipu-knot` (the accent by default),
 * so the mark follows the active theme, light mode included.
 */
export function QuipuMark({ size = 20, className = '', title }: { size?: number; className?: string; title?: string }) {
  return (
    <svg
      className={`quipu-mark ${className}`.trim()}
      width={size}
      height={size}
      viewBox={VIEW_BOX}
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <g stroke="currentColor" strokeLinecap="round">
        <path d={SHAPES.cord} strokeWidth={QUIPU.cord.width} />
        <path d={SHAPES.pendants.join('')} strokeWidth={QUIPU.pendantWidth} />
      </g>
      <g className="quipu-mark-knots">
        {SHAPES.knots.map((k) => <circle key={`${k.cx}-${k.cy}`} cx={k.cx} cy={k.cy} r={QUIPU.knotRadius} />)}
      </g>
    </svg>
  )
}
